<template>
  <!-- 对话框 -->
  <el-dialog
    :visible.sync="show"
    width="500px"
    :before-close="closeDialog"
    center
  >

    <div
      style="max-height: 50vh ;overflow-y: auto;"
      class="box"
      v-if="data_lists!=null"
    >
      <el-form label-width="80px">

        <el-form-item
          label="评价星级:"
          label-width='120px'
        >

          {{ data_lists.star_point }}星

        </el-form-item>

        <el-form-item
          label="评价内容:"
          label-width='120px'
        >

          {{ data_lists.remarks }}

        </el-form-item>

        <el-form-item
          label="评价时间:"
          label-width='120px'
        >

          {{ data_lists.time.YmdHis }}

        </el-form-item>

      </el-form>

    </div>

    <!-- 对话框底部按钮 -->
    <span
      slot="footer"
      class="dialog-footer"
    >

      <el-button @click="closeDialog">返回</el-button>
    </span>

  </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data.order_code = _this.data;

            _this
                .$post('/admin.php/order/getOrderAssessDetails', _this.submit_data)
                .then((res) => {
                    _this.data_lists = res.data;
                })
                .catch((res) => {});
        }
    },
    data() {
        return {
            show: false,

            data_lists: [],

            // 表单数据
            submit_data: {
                order_code: '',
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        closeDialog() {
            _this.submit_data = {
                order_code: '',
            };
            _this.show = false;

            // 清空数据
            _this.$nextTick(function() {
              _this.data_lists = [];

            })

        }
    }
};
</script>

<style scoped>
#container_add {
    height: 90%;
    width: 65%;
    float: left;
}

.order-model {
    margin: 20px 0;
}

.mode-data {
    margin: 20px 0;
}

iframe {
    width: 100%;
    border: medium none;
    height: 100%;
}

h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
}

h5 {
    font-size: 20px;
    font-weight: normal;
}

.text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
}

.box > div {
    margin: 20px 0;
}
</style>